// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"cc30d57c","68":"06c9e28b"}[chunkId] + ".chunk.css";
};